import { useContext, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { DashboardContext } from "../../../contexts/Dashboard/DashboardContext";
import { AuthContext } from "../../../contexts/Authentication/AuthContext";
import ModalConfirmation from "./ModalConfirmation";
import "./styles.css";
import { toast } from "react-toastify";

const VisualizeEditButton = () => {
  const navigate = useNavigate();
  const { id, mode } = useParams();
  const { changesSaved, titlePage } = useContext(DashboardContext);
  const { isAuthenticated, hasShortToken } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);

  function onClickVisualizeButton() {
    if (!titlePage) {
      toast.error("Título é obrigatório!", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (changesSaved) {
      navigate(`/dashboard/view/${id}`);
    } else {
      setShowModal(true);
    }
  }

  const handleModal = (handle: boolean) => {
    setShowModal(handle);
  };

  function onClickEditButton() {
    navigate(`/dashboard/edit/${id}`);
  }

  return !hasShortToken ? (
    <>
      <ButtonGroup>
        <ToggleButton
          key="view-btn"
          id="id-view-btn"
          className="button-edit-view"
          value={0}
          disabled={mode === "view"}
          onClick={() => onClickVisualizeButton()}
        >
          Visualizar
        </ToggleButton>
        <ToggleButton
          key="edit-btn"
          id="id-edit-btn"
          className="button-edit-view"
          value={1}
          disabled={mode === "edit" && isAuthenticated}
          onClick={() => onClickEditButton()}
        >
          Editar
        </ToggleButton>
      </ButtonGroup>
      <ModalConfirmation show={showModal} changeModal={handleModal} />
    </>
  ) : (
    <></>
  );
};

export default VisualizeEditButton;
